import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import ConditionalWrapper from '@wix/da-shared-react/pkg/ConditionalWrapper';

import s from './MonetizationPromoBanner.scss';

export interface Props {
  className?: string;
  monetizationPromo?: string;
  profileOwnerUser: PapiUser;
}

export const MonetizationPromoBanner: React.FC<Props> = ({
  monetizationPromo,
  profileOwnerUser,
  className,
}) => {
  const { t } = useTranslation();
  const { username, userId } = profileOwnerUser;
  const isMobile = useContext(MobileContext);

  const checkOut = useCallback(() => {
    let checkOutURL;
    if (monetizationPromo === 'tier') {
      checkOutURL = Url.userSubscriptionsPath({
        username,
      });
    } else {
      checkOutURL = Url.userShopLink(
        username,
        USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS
      );
    }
    window.location.href = checkOutURL;
  }, [username, monetizationPromo]);

  if (
    !monetizationPromo ||
    !['tier', 'commission'].includes(monetizationPromo)
  ) {
    return null;
  }

  const biData = {
    evid:
      monetizationPromo === 'tier'
        ? BiEventType.VIEW_SUBSCRIPTION_TAB
        : BiEventType.VIEW_COMMISSIONS_TAB,
    typeid: ResourceType.USER,
    itemid: userId,
    referral_info: ReferralType.PROFILE_COVER_PROMOTION,
  };

  return (
    <div
      className={c(
        s['root'],
        s[`type-${monetizationPromo}`],
        s['ms-ads-mobile'],
        className
      )}
    >
      <div className={s['container']}>
        <ConditionalWrapper
          condition={isMobile}
          wrap={child => (
            <BiLink className={s['link']} onClick={checkOut} biData={biData}>
              {child}
            </BiLink>
          )}
        >
          <div className={s['body']}>
            {t(
              `common.profileHero.moneyBanner.var.${monetizationPromo}.message`
            )}
          </div>
          {!isMobile && (
            <BiLink className={s['link']} onClick={checkOut} biData={biData}>
              {t('common.profileHero.moneyBanner.CTA')}
            </BiLink>
          )}
        </ConditionalWrapper>
      </div>
    </div>
  );
};
MonetizationPromoBanner.displayName = 'MonetizationPromoBanner';

export default MonetizationPromoBanner;
